import React, { useEffect } from 'react';

import { THEME_IDS } from '../../../constants';

interface WidgetLayoutProps extends React.PropsWithChildren {
  config?: Record<string, any>;
  className?: string;
}

const WidgetLayout: React.FC<WidgetLayoutProps> = ({
  children,
  config,
  className = '',
}) => {
  const isGSMA = config?.context === THEME_IDS.GSMA;
  useEffect(() => {
    if (isGSMA) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = config?.environments?.settings?.widgetCSSUrl;
      link.id = 'widget-layout-styles';
      document.head.appendChild(link);

      return () => {
        const existingLink = document.getElementById('widget-layout-styles');
        if (existingLink) {
          document.head.removeChild(existingLink);
        }
      };
    }
  }, [isGSMA, config?.environments?.settings?.widgetCSSUrl]);

  return <main className={`c-iFrameAuth ${className}`}>{children}</main>;
};

export default WidgetLayout;
